import { Injectable } from '@angular/core';
import { SmartTableData } from '../data/smart-table';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Globals } from '../../../global';

@Injectable()
export class SmartTableService extends SmartTableData {
  public _http:HttpClient;

  data = [{
    id: 1,
    nombre: 'Mark',
    apellidos: 'Otto',
    telefono: '677 591 395',
    email: 'mdo@gmail.com',
  }, {
    id: 2,
    nombre: 'Edd',
    apellidos: 'Jenkin',
    telefono: '695 960 253',
    email: 'ed@gmail.com',
  }];

  getData(token?) {
    
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer '+token+''
      })
    };
    let datos = this._http.get('https://'+ Globals.DOMAIN_NAME +'/Bsedic/public/api/v1/usuario',httpOptions);
    return this.data;
  }
}
